import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';

import { ProductFormModalCallBackData } from '../../../products/product-form/product-form.page';
import { ProductService } from '../../../services/product.service';
import { UserService } from '../../../services/user.service';
import { Product } from '../../../models/product/product.model';
import { Stylist } from '../../../models/stylist/stylist.model';
//import { ProductSelectEvent } from '../../../components/product-list/product-list.component';
import { ProductSelectEvent } from 'src/app/models';
import { StylistPickerComponent } from '../../../components/stylist-picker/stylist-picker.component';
import { List } from 'immutable';
import { ProductFormPage } from '../../../products/product-form/product-form.page';
// import { BarcodeScanner, BarcodeScanResult } from '@awesome-cordova-plugins/barcode-scanner';
@Component({
  selector: 'app-sale-product-picker',
  templateUrl: './sale-product-picker.page.html',
  styleUrls: ['./sale-product-picker.page.scss'],
})
export class SaleProductPickerPage implements OnInit {
  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public isLoading: boolean;

  public errorOccurredWhileLoadingProducts: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  // public products: List<Product>;

  public readOnlyStylistPicker: boolean;

  @Input() stylist: Stylist;

  public searchVal: string;

  public rows: List<Product> = List([]);

  public products: List<Product> = List([]);

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private userService: UserService,
    private productService: ProductService,
    private modalController: ModalController,
    private alertController: AlertController,
    //private navParams: NavParams,
    // private barcodeScanner: BarcodeScanner,
    public platform: Platform,
    //private viewController: ViewController,
    private modalCtrl: ModalController
  ) {
    this.isLoading = true;

    //const stylist: Stylist = this.navParams.get('stylist');

    const stylist: Stylist = this.stylist;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.onStylistSelect(stylist ? stylist : user.clone());
      if (user.isAdministrator() || user.getViewAllCalendars() === 1) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }
  }

  public ngOnInit() {
    if (!this.stylist) this.stylist = this.userService.getUser();
    this.loadProducts();
  }

  public onTapToReload() {
    this.isLoading = true;
    if (this.errorOccurredWhileLoadingStylistPicker) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.stylistPickerComponent.ngOnInit();
    } else if (this.errorOccurredWhileLoadingProducts) {
      this.errorOccurredWhileLoadingProducts = false;
      this.loadProducts();
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.stylist = stylist;
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
      this.loadProducts();
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  public loadProducts() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingProducts = false;
    this.products = List([]);

    this.productService.loadProducts().subscribe({
      next: (products) => {
        this.isLoading = false;
        this.products = products;
        this.rows = this.products;
        this.changeDetectorRef.markForCheck();
      },
      error: (e) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingProducts = true;
        this.changeDetectorRef.markForCheck();
      },
    });
  }

  public onDismiss() {
    // this.viewController.dismiss();
    this.modalCtrl.dismiss();
  }

  public productSelect(event: ProductSelectEvent) {
    event.product = event.product.setStylist(this.stylist);
    //this.viewController.dismiss(event.product);
    this.modalCtrl.dismiss(event.product);
  }

  public async createProduct() {
    const modal = await this.modalController.create({
      component: ProductFormPage,
      componentProps: { isModal: true },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data) {
        this.products = this.products.push(data.product);
        this.changeDetectorRef.markForCheck();
      }
    });
    await modal.present();
  }

  public onSearch() {
    this.rows = this.findProductByVal(this.searchVal);
    this.changeDetectorRef.markForCheck();
  }

  public findProductByVal(value: string): List<Product> {
    if (value !== null && value !== '') {
      // search
      const rows = this.products.filter((product) => {
        if (parseInt(value, 10) === product.id) {
          return true;
        }

        const searchString: string = value.toLowerCase();

        if (product.name) {
          if (product.name.toLowerCase().indexOf(searchString) > -1) {
            return true;
          }
        }

        if (product.brand) {
          if (product.brand.getName().toLowerCase().indexOf(searchString) > -1) {
            return true;
          }
        }

        if (product.productCode) {
          if (product.productCode.toLowerCase().indexOf(searchString) > -1) {
            return true;
          }
        }
      });

      // this.rows = List(rows);
      // this.changeDetectorRef.markForCheck();
      return List(rows);
    } else {
      // resert filter
      // this.rows = this.products;
      // this.changeDetectorRef.markForCheck();
      return this.products;
    }
  }

  public onBarcodeScan() {
    // this.barcodeScanner.scan().then(barcodeData => {
    //   const result: List<Product> = this.findProductByVal(barcodeData.text);
    //   if (result.count() > 0) {
    //     this.productSelect({
    //       index: 0,
    //       product: result.get(0)
    //     })
    //   } else {
    //     this.searchVal = barcodeData.text;
    //     this.changeDetectorRef.markForCheck();
    //   }
    // })
    // .catch(err => {
    // });
  }
}
